import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "wizard-stepper q-px-lg q-pt-md q-pb-sm" }
const _hoisted_2 = { class: "row items-center justify-center no-wrap" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "wizard-stepper-circle" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "wizard-stepper-label q-mt-xs" }
const _hoisted_7 = { class: "column q-gutter-sm" }
const _hoisted_8 = {
  key: 0,
  class: "q-ml-lg q-mb-sm wizard-body-text text-grey-8"
}
const _hoisted_9 = {
  key: 1,
  class: "q-ml-lg q-mb-sm wizard-body-text text-grey-8"
}
const _hoisted_10 = {
  key: 2,
  class: "q-ml-lg q-mb-sm wizard-body-text text-grey-8"
}
const _hoisted_11 = { class: "row q-gutter-md" }
const _hoisted_12 = {
  class: "col",
  style: {"max-width":"500px"}
}
const _hoisted_13 = { class: "q-gutter-md" }
const _hoisted_14 = { class: "row items-center q-gutter-sm" }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = {
  ref: "wizardPreviewMap",
  style: {"height":"220px","width":"100%","border":"1px solid #ccc","border-radius":"4px"}
}
const _hoisted_17 = {
  key: 0,
  class: "flex items-center justify-center text-grey-5 text-caption text-center",
  style: {"height":"220px","border":"1px dashed #ccc","border-radius":"4px"}
}
const _hoisted_18 = { class: "row q-gutter-md" }
const _hoisted_19 = {
  class: "col",
  style: {"max-width":"500px"}
}
const _hoisted_20 = { class: "q-gutter-md" }
const _hoisted_21 = { class: "row items-center q-gutter-sm" }
const _hoisted_22 = { class: "col" }
const _hoisted_23 = {
  ref: "wizardPreviewMapR",
  style: {"height":"220px","width":"100%","border":"1px solid #ccc","border-radius":"4px"}
}
const _hoisted_24 = {
  key: 0,
  class: "flex items-center justify-center text-grey-5 text-caption text-center",
  style: {"height":"220px","border":"1px dashed #ccc","border-radius":"4px"}
}
const _hoisted_25 = { class: "text-right" }
const _hoisted_26 = { class: "text-right" }
const _hoisted_27 = { class: "text-right" }
const _hoisted_28 = { class: "text-left" }
const _hoisted_29 = { class: "text-right" }
const _hoisted_30 = { class: "text-right" }
const _hoisted_31 = { class: "text-right" }
const _hoisted_32 = { class: "q-gutter-sm q-mb-md" }
const _hoisted_33 = { class: "q-gutter-sm q-mb-md" }
const _hoisted_34 = { class: "q-gutter-sm q-mb-sm" }
const _hoisted_35 = { class: "q-mb-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_radio = _resolveComponent("q-radio")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_AgmPicker = _resolveComponent("AgmPicker")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_markup_table = _resolveComponent("q-markup-table")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_PipelineSectionManager = _resolveComponent("PipelineSectionManager")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.wizardDialog,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.wizardDialog) = $event)),
      onHide: _ctx.onWizardDialogHide
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, {
          class: "wizard-card",
          style: {"width":"850px","max-width":"95vw"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar_title, { class: "wizard-dialog-title" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.isEditMode ? 'Edit Pig Run' : 'New Pig Run Wizard'), 1)
                  ]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.wizardStepDefinitions, (stepDef, idx) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: 'step-' + stepDef.step
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["wizard-stepper-item column items-center", {
                  'wizard-stepper-active': _ctx.wizardStep === stepDef.step,
                  'wizard-stepper-completed': _ctx.isStepCompleted(stepDef.step),
                  'wizard-stepper-clickable':
                    stepDef.step <= _ctx.wizardMaxStepReached,
                  'wizard-stepper-disabled':
                    stepDef.step > _ctx.wizardMaxStepReached,
                }]),
                      onClick: ($event: any) => (_ctx.onWizardGoToStep(stepDef.step))
                    }, [
                      _createElementVNode("div", _hoisted_4, [
                        (_ctx.isStepCompleted(stepDef.step))
                          ? (_openBlock(), _createBlock(_component_q_icon, {
                              key: 0,
                              name: "check",
                              size: "16px"
                            }))
                          : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(idx + 1), 1))
                      ]),
                      _createElementVNode("div", _hoisted_6, _toDisplayString(stepDef.label), 1)
                    ], 10, _hoisted_3),
                    (idx < _ctx.wizardStepDefinitions.length - 1)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["wizard-stepper-line", {
                  'wizard-stepper-line-completed': _ctx.isStepCompleted(
                    stepDef.step
                  ),
                }])
                        }, null, 2))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ])
            ]),
            _createVNode(_component_q_separator),
            (_ctx.wizardStep === 1)
              ? (_openBlock(), _createBlock(_component_q_card_section, { key: 0 }, {
                  default: _withCtx(() => [
                    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "wizard-step-title q-mb-md" }, " What type of pig run would you like to create? ", -1)),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_q_radio, {
                        modelValue: _ctx.wizardRunType,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.wizardRunType) = $event)),
                        val: "live-tracked",
                        label: "Live-Tracked",
                        color: "blue-brand"
                      }, null, 8, ["modelValue"]),
                      (_ctx.wizardRunType === 'live-tracked')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[24] || (_cache[24] = [
                            _createTextVNode(" A Live-Tracked Pig Run represents an active pipeline inspection run where the pig's location is continuously updated in real time as it moves through the pipeline. The system ingests live passage detections from Above Ground Markers (AGMs) and dynamically calculates the pig's estimated position along the pipeline path. ", -1),
                            _createElementVNode("br", null, null, -1),
                            _createElementVNode("br", null, null, -1),
                            _createTextVNode(" The map view becomes the operational control center. ", -1)
                          ]))]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_q_radio, {
                        modelValue: _ctx.wizardRunType,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.wizardRunType) = $event)),
                        val: "reconstructed",
                        label: "Reconstructed",
                        color: "blue-brand"
                      }, null, 8, ["modelValue"]),
                      (_ctx.wizardRunType === 'reconstructed')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Creates a completed pig run by associating previously transmitted passage detections with the defined pipeline markers. This run type does not track the pig in real time, but instead reconstructs the pig's path and timing using stored detection data. "))
                        : _createCommentVNode("", true),
                      _createVNode(_component_q_radio, {
                        modelValue: _ctx.wizardRunType,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.wizardRunType) = $event)),
                        val: "unknown",
                        label: "I don't know",
                        color: "blue-brand"
                      }, null, 8, ["modelValue"]),
                      (_ctx.wizardRunType === 'unknown')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.wizardStep === 2 && _ctx.wizardRunType !== 'reconstructed')
              ? (_openBlock(), _createBlock(_component_q_card_section, { key: 1 }, {
                  default: _withCtx(() => [
                    _cache[27] || (_cache[27] = _createElementVNode("div", { class: "wizard-step-title q-mb-md" }, "General", -1)),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_q_input, {
                            modelValue: _ctx.wizardName,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.wizardName) = $event)),
                            dense: "",
                            outlined: "",
                            color: "blue-brand",
                            label: "Name",
                            maxlength: "500",
                            rules: [
                    (val) => !!val || 'Name is required.',
                    (val) =>
                      (val && val.length <= 500) ||
                      'Name must be 500 characters or less.',
                  ]
                          }, null, 8, ["modelValue", "rules"]),
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_q_select, {
                              modelValue: _ctx.wizardPipelineSection,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.wizardPipelineSection) = $event)),
                              dense: "",
                              outlined: "",
                              color: "blue-brand",
                              label: "Pipeline",
                              options: _ctx.wizardPipelineSectionOptions,
                              clearable: "",
                              class: "col"
                            }, null, 8, ["modelValue", "options"]),
                            _createVNode(_component_q_btn, {
                              flat: "",
                              dense: "",
                              round: "",
                              icon: "settings",
                              color: "blue-brand",
                              onClick: _ctx.onManagePipelineSectionOpen
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_tooltip, null, {
                                  default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                    _createTextVNode("Create or update pipelines", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _createVNode(_component_q_input, {
                            modelValue: _ctx.wizardJobNumber,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.wizardJobNumber) = $event)),
                            dense: "",
                            outlined: "",
                            color: "blue-brand",
                            label: "Job Number",
                            maxlength: "50",
                            rules: [
                    (val) =>
                      !val ||
                      val.length <= 50 ||
                      'Job Number must be 50 characters or less.',
                  ]
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_q_input, {
                            modelValue: _ctx.wizardNote,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.wizardNote) = $event)),
                            dense: "",
                            outlined: "",
                            color: "blue-brand",
                            label: "Note",
                            type: "textarea",
                            autogrow: ""
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _withDirectives(_createElementVNode("div", _hoisted_16, null, 512), [
                          [_vShow, _ctx.wizardPipelineSection]
                        ]),
                        (!_ctx.wizardPipelineSection)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, " Select a pipeline to preview markers "))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.wizardStep === 2 && _ctx.wizardRunType === 'reconstructed')
              ? (_openBlock(), _createBlock(_component_q_card_section, { key: 2 }, {
                  default: _withCtx(() => [
                    _cache[29] || (_cache[29] = _createElementVNode("div", { class: "wizard-step-title q-mb-md" }, "General", -1)),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_component_q_input, {
                            modelValue: _ctx.wizardName,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.wizardName) = $event)),
                            dense: "",
                            outlined: "",
                            color: "blue-brand",
                            label: "Name",
                            maxlength: "500",
                            rules: [
                    (val) => !!val || 'Name is required.',
                    (val) =>
                      (val && val.length <= 500) ||
                      'Name must be 500 characters or less.',
                  ]
                          }, null, 8, ["modelValue", "rules"]),
                          _createElementVNode("div", _hoisted_21, [
                            _createVNode(_component_q_select, {
                              modelValue: _ctx.wizardPipelineSection,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.wizardPipelineSection) = $event)),
                              dense: "",
                              outlined: "",
                              color: "blue-brand",
                              label: "Pipeline",
                              options: _ctx.wizardPipelineSectionOptions,
                              clearable: "",
                              class: "col"
                            }, null, 8, ["modelValue", "options"]),
                            _createVNode(_component_q_btn, {
                              flat: "",
                              dense: "",
                              round: "",
                              icon: "settings",
                              color: "blue-brand",
                              onClick: _ctx.onManagePipelineSectionOpen
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_tooltip, null, {
                                  default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                    _createTextVNode("Create or update pipelines", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _createVNode(_component_q_input, {
                            modelValue: _ctx.wizardJobNumber,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.wizardJobNumber) = $event)),
                            dense: "",
                            outlined: "",
                            color: "blue-brand",
                            label: "Job Number",
                            maxlength: "50",
                            rules: [
                    (val) =>
                      !val ||
                      val.length <= 50 ||
                      'Job Number must be 50 characters or less.',
                  ]
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_q_input, {
                            modelValue: _ctx.wizardNote,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.wizardNote) = $event)),
                            dense: "",
                            outlined: "",
                            color: "blue-brand",
                            label: "Note",
                            type: "textarea",
                            autogrow: ""
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _withDirectives(_createElementVNode("div", _hoisted_23, null, 512), [
                          [_vShow, _ctx.wizardPipelineSection]
                        ]),
                        (!_ctx.wizardPipelineSection)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, " Select a pipeline to preview markers "))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.wizardStep === 3)
              ? (_openBlock(), _createBlock(_component_q_card_section, { key: 3 }, {
                  default: _withCtx(() => [
                    _cache[30] || (_cache[30] = _createElementVNode("div", { class: "wizard-step-title q-mb-md" }, "AGMs", -1)),
                    _createVNode(_component_AgmPicker, {
                      "available-agms": _ctx.wizardAvailableAgms,
                      "selected-agms": _ctx.wizardSelectedAgms,
                      "active-run-agm-ids": _ctx.activeRunAgmIds,
                      "onUpdate:availableAgms": _cache[11] || (_cache[11] = ($event: any) => (_ctx.wizardAvailableAgms = $event)),
                      "onUpdate:selectedAgms": _cache[12] || (_cache[12] = ($event: any) => (_ctx.wizardSelectedAgms = $event))
                    }, null, 8, ["available-agms", "selected-agms", "active-run-agm-ids"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.wizardStep === 4)
              ? (_openBlock(), _createBlock(_component_q_card_section, { key: 4 }, {
                  default: _withCtx(() => [
                    _cache[38] || (_cache[38] = _createElementVNode("div", { class: "wizard-step-title q-mb-md" }, "Broadcast Commands", -1)),
                    _createVNode(_component_q_markup_table, null, {
                      default: _withCtx(() => [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _cache[37] || (_cache[37] = _createElementVNode("th", { class: "text-left" }, [
                              _createElementVNode("span", { class: "text-bold" }, "Command")
                            ], -1)),
                            _createElementVNode("th", _hoisted_25, [
                              _cache[32] || (_cache[32] = _createElementVNode("span", { class: "text-bold q-pr-sm" }, "Now", -1)),
                              _createVNode(_component_q_icon, { name: "fas fa-info-circle" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_tooltip, null, {
                                    default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                                      _createTextVNode("Commands to be sent to AGMs when this pig run is saved.", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("th", _hoisted_26, [
                              _cache[34] || (_cache[34] = _createElementVNode("span", { class: "text-bold q-pr-sm" }, "Launch", -1)),
                              _createVNode(_component_q_icon, { name: "fas fa-info-circle" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_tooltip, null, {
                                    default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                                      _createTextVNode("Commands to be sent to AGMs when the pig is launched.", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("th", _hoisted_27, [
                              _cache[36] || (_cache[36] = _createElementVNode("span", { class: "text-bold q-pr-sm" }, "Receive", -1)),
                              _createVNode(_component_q_icon, { name: "fas fa-info-circle" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_tooltip, null, {
                                    default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                                      _createTextVNode("Commands to be sent to AGMs when the pig run is ended/saved.", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.broadcastCommandDefinitions, (def) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: def.broadcastCommandId
                            }, [
                              _createElementVNode("td", _hoisted_28, _toDisplayString(def.label), 1),
                              _createElementVNode("td", _hoisted_29, [
                                _createVNode(_component_q_checkbox, {
                                  modelValue: 
                      _ctx.wizardBroadcastCommandSelections[
                        _ctx.broadcastCommandDefinitions.indexOf(def)
                      ].isNow
                    ,
                                  "onUpdate:modelValue": ($event: any) => ((
                      _ctx.wizardBroadcastCommandSelections[
                        _ctx.broadcastCommandDefinitions.indexOf(def)
                      ].isNow
                    ) = $event),
                                  color: "blue-brand",
                                  disable: def.disableNow
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "disable"])
                              ]),
                              _createElementVNode("td", _hoisted_30, [
                                _createVNode(_component_q_checkbox, {
                                  modelValue: 
                      _ctx.wizardBroadcastCommandSelections[
                        _ctx.broadcastCommandDefinitions.indexOf(def)
                      ].isLaunch
                    ,
                                  "onUpdate:modelValue": ($event: any) => ((
                      _ctx.wizardBroadcastCommandSelections[
                        _ctx.broadcastCommandDefinitions.indexOf(def)
                      ].isLaunch
                    ) = $event),
                                  color: "blue-brand",
                                  disable: def.disableLaunch
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "disable"])
                              ]),
                              _createElementVNode("td", _hoisted_31, [
                                _createVNode(_component_q_checkbox, {
                                  modelValue: 
                      _ctx.wizardBroadcastCommandSelections[
                        _ctx.broadcastCommandDefinitions.indexOf(def)
                      ].isReceive
                    ,
                                  "onUpdate:modelValue": ($event: any) => ((
                      _ctx.wizardBroadcastCommandSelections[
                        _ctx.broadcastCommandDefinitions.indexOf(def)
                      ].isReceive
                    ) = $event),
                                  color: "blue-brand",
                                  disable: def.disableReceive
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "disable"])
                              ])
                            ]))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.wizardStep === 6)
              ? (_openBlock(), _createBlock(_component_q_card_section, { key: 5 }, {
                  default: _withCtx(() => [
                    _cache[42] || (_cache[42] = _createElementVNode("div", { class: "wizard-step-title q-mb-md" }, "Notification", -1)),
                    _createVNode(_component_q_select, {
                      modelValue: _ctx.wizardSelectedNotificationUser,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.wizardSelectedNotificationUser) = $event)),
                      options: _ctx.wizardNotificationUsers,
                      label: "Select User",
                      outlined: "",
                      dense: "",
                      color: "blue-brand",
                      style: {"max-width":"300px"},
                      class: "q-mb-lg"
                    }, null, 8, ["modelValue", "options"]),
                    (_ctx.wizardSelectedNotificationUser)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _cache[39] || (_cache[39] = _createElementVNode("div", { class: "wizard-section-title q-mb-sm" }, "Notification Channel", -1)),
                          _createElementVNode("div", _hoisted_32, [
                            _createVNode(_component_q_checkbox, {
                              modelValue: 
                  _ctx.wizardUserNotificationSettings[
                    _ctx.wizardSelectedNotificationUser.value
                  ].channelEmail
                ,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((
                  _ctx.wizardUserNotificationSettings[
                    _ctx.wizardSelectedNotificationUser.value
                  ].channelEmail
                ) = $event)),
                              label: "EMAIL",
                              color: "blue-brand"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_q_checkbox, {
                              modelValue: 
                  _ctx.wizardUserNotificationSettings[
                    _ctx.wizardSelectedNotificationUser.value
                  ].channelSms
                ,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((
                  _ctx.wizardUserNotificationSettings[
                    _ctx.wizardSelectedNotificationUser.value
                  ].channelSms
                ) = $event)),
                              label: "SMS",
                              color: "blue-brand"
                            }, null, 8, ["modelValue"])
                          ]),
                          _cache[40] || (_cache[40] = _createElementVNode("div", { class: "wizard-section-title q-mb-sm" }, "Pig Run Events", -1)),
                          _createElementVNode("div", _hoisted_33, [
                            _createVNode(_component_q_checkbox, {
                              modelValue: 
                  _ctx.wizardUserNotificationSettings[
                    _ctx.wizardSelectedNotificationUser.value
                  ].atLaunch
                ,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((
                  _ctx.wizardUserNotificationSettings[
                    _ctx.wizardSelectedNotificationUser.value
                  ].atLaunch
                ) = $event)),
                              label: "At Launch",
                              color: "blue-brand"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_q_checkbox, {
                              modelValue: 
                  _ctx.wizardUserNotificationSettings[
                    _ctx.wizardSelectedNotificationUser.value
                  ].atReceive
                ,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((
                  _ctx.wizardUserNotificationSettings[
                    _ctx.wizardSelectedNotificationUser.value
                  ].atReceive
                ) = $event)),
                              label: "At Receive",
                              color: "blue-brand"
                            }, null, 8, ["modelValue"])
                          ]),
                          _cache[41] || (_cache[41] = _createElementVNode("div", { class: "wizard-section-title q-mb-sm" }, " Marker Passage Events ", -1)),
                          _createElementVNode("div", _hoisted_34, [
                            _createVNode(_component_q_checkbox, {
                              modelValue: 
                  _ctx.wizardUserNotificationSettings[
                    _ctx.wizardSelectedNotificationUser.value
                  ].verifiedPassage
                ,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((
                  _ctx.wizardUserNotificationSettings[
                    _ctx.wizardSelectedNotificationUser.value
                  ].verifiedPassage
                ) = $event)),
                              label: "Verified Passage",
                              color: "blue-brand"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_q_checkbox, {
                              modelValue: 
                  _ctx.wizardUserNotificationSettings[
                    _ctx.wizardSelectedNotificationUser.value
                  ].manualPassage
                ,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((
                  _ctx.wizardUserNotificationSettings[
                    _ctx.wizardSelectedNotificationUser.value
                  ].manualPassage
                ) = $event)),
                              label: "Manual Passage",
                              color: "blue-brand"
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            _createVNode(_component_q_checkbox, {
                              modelValue: 
                  _ctx.wizardUserNotificationSettings[
                    _ctx.wizardSelectedNotificationUser.value
                  ].allMarkers
                ,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((
                  _ctx.wizardUserNotificationSettings[
                    _ctx.wizardSelectedNotificationUser.value
                  ].allMarkers
                ) = $event)),
                              label: "All Markers",
                              color: "blue-brand"
                            }, null, 8, ["modelValue"]),
                            (
                  !_ctx.wizardUserNotificationSettings[
                    _ctx.wizardSelectedNotificationUser.value
                  ].allMarkers
                )
                              ? (_openBlock(), _createBlock(_component_q_select, {
                                  key: 0,
                                  modelValue: 
                  _ctx.wizardUserNotificationSettings[
                    _ctx.wizardSelectedNotificationUser.value
                  ].selectedMarkers
                ,
                                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((
                  _ctx.wizardUserNotificationSettings[
                    _ctx.wizardSelectedNotificationUser.value
                  ].selectedMarkers
                ) = $event)),
                                  options: _ctx.wizardNotificationMarkers,
                                  label: "Select Markers",
                                  outlined: "",
                                  dense: "",
                                  multiple: "",
                                  "use-chips": "",
                                  color: "blue-brand",
                                  style: {"max-width":"500px"},
                                  class: "q-mt-sm"
                                }, null, 8, ["modelValue", "options"]))
                              : _createCommentVNode("", true)
                          ])
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_q_card_actions, { align: "right" }, {
              default: _withCtx(() => [
                (_ctx.wizardStep > 1)
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      "no-caps": "",
                      class: "btn-brand",
                      label: "Back",
                      onClick: _ctx.onWizardBack
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (
              _ctx.wizardStep < 6 &&
              !(_ctx.wizardStep === 3 && _ctx.wizardRunType === 'reconstructed')
            )
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 1,
                      "no-caps": "",
                      class: "btn-brand",
                      label: "Next",
                      disable: _ctx.wizardStep === 1 && _ctx.wizardRunType === '',
                      onClick: _ctx.onWizardNext
                    }, null, 8, ["disable", "onClick"]))
                  : _createCommentVNode("", true),
                (
              _ctx.wizardStep === 6 ||
              (_ctx.wizardStep === 3 && _ctx.wizardRunType === 'reconstructed')
            )
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 2,
                      "no-caps": "",
                      class: "btn-brand",
                      label: _ctx.isEditMode ? 'Update' : 'Save',
                      onClick: _ctx.onWizardSave
                    }, null, 8, ["label", "onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "onHide"]),
    _createVNode(_component_PipelineSectionManager, {
      modelValue: _ctx.managePipelineSectionDialog,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.managePipelineSectionDialog) = $event)),
      onSectionsUpdated: _ctx.onPipelineSectionsUpdated
    }, null, 8, ["modelValue", "onSectionsUpdated"])
  ]))
}